exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MnpStatus_description_2s30 {\n  margin-bottom: 10px;\n}\n\n.MnpStatus_closeButton_AIHr {\n  padding: 0;\n\n  font-size: 21px;\n\n  border: none;\n  background: none;\n\n  -webkit-transition: color 0.15s;\n\n  transition: color 0.15s;\n\n  cursor: pointer\n}\n\n.MnpStatus_closeButton_AIHr:hover {\n  color: #f6a000;\n  -webkit-transition: none;\n  transition: none;\n}\n", ""]);

// exports
exports.locals = {
	"description": "MnpStatus_description_2s30",
	"closeButton": "MnpStatus_closeButton_AIHr"
};